module.exports = new __parcel__URL__("organization.cd8f5da8.png").toString();